// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toastify {
    z-index: 10000;
}

.toastify--bottom-center {
    min-width: 600px;
    margin-left: -300px;
    margin-bottom: 40px;
}

.dropzone {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 80px;
    border: 1px solid lightgray;
    border-radius: 4px;
    background-color: rgb(243, 244, 245);
}

.dropzone-no-border {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 80px;
    border: none;
    background-color: rgb(243, 244, 245);
}

.react-datepicker-wrapper {
    width: 100%;
}

.react-datepicker__input-container {
    width: 100%;
}

.react-datepicker__input-container .date-picker-input {
    font-weight: normal;
    border: none;
    width: 100%;
}

.react-autosuggest__container {
    position: relative;
}

.react-autosuggest__input {
    width: 100%;
    border: 1px solid #aaa;
    border-radius: 4px;
}

.react-autosuggest__input--focused {
    outline: none;
}

.react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.react-autosuggest__suggestions-container {
    display: none;
}

.react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    top: 29px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: #fff;
    font-weight: normal;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: left;
    z-index: 2;
}

.react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
}

.react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
}

.react-autosuggest__input_inputgroup {
    width: 100%;
    height: 30px;
    padding: 0 10px;
    border: none;
    font-weight: normal;
    border-radius: 0;
}
.ReactTable {
    border: none;
}

.ReactTable .rt-thead.-header {
    background-color: rgb(249, 250, 251);
    border-bottom: 1px solid rgba(34, 36, 38, 0.0980392);
    box-shadow: none;
}

.ReactTable .rt-td.-menu {
    overflow: visible;
}

.ui.edit-input>input {
    border: none;
    padding: 2px 4px;
}

.ui.pagejump>input {
    width: 60px;
    text-align: right;
}

.ui.compartment-search > input {
    border: none;
    border-radius: 0;
}

.ui.compartment-search.ui.button {
    border: none;
    border-radius: 0;
}

.neuroglancer-side-panel-titlebar.neuroglancer-layer-side-panel-title {
    background-color: rgb(39, 128, 220) !important;
}

.neuroglancer-viewer-top-row {
    background-color: rgb(39, 128, 220) !important;
}

#neuroglancer-container {
    overflow: hidden;
    flex: 1;
    color: white;
    border: 0 solid black;
    border-radius: 4px;
    box-shadow: 0 1px 2px 0 rgba(34, 36, 38, .1);
    box-sizing: content-box;
    webkit-box-sizing: content-box;
}

#neuroglancer-container input {
    margin: 3px
}
`, "",{"version":3,"sources":["webpack://./../assets/style.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,+BAA+B;IAC/B,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;IACpD,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,gBAAgB;IAChB,OAAO;IACP,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,4CAA4C;IAC5C,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI;AACJ","sourcesContent":[".toastify {\n    z-index: 10000;\n}\n\n.toastify--bottom-center {\n    min-width: 600px;\n    margin-left: -300px;\n    margin-bottom: 40px;\n}\n\n.dropzone {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    min-height: 80px;\n    border: 1px solid lightgray;\n    border-radius: 4px;\n    background-color: rgb(243, 244, 245);\n}\n\n.dropzone-no-border {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    min-height: 80px;\n    border: none;\n    background-color: rgb(243, 244, 245);\n}\n\n.react-datepicker-wrapper {\n    width: 100%;\n}\n\n.react-datepicker__input-container {\n    width: 100%;\n}\n\n.react-datepicker__input-container .date-picker-input {\n    font-weight: normal;\n    border: none;\n    width: 100%;\n}\n\n.react-autosuggest__container {\n    position: relative;\n}\n\n.react-autosuggest__input {\n    width: 100%;\n    border: 1px solid #aaa;\n    border-radius: 4px;\n}\n\n.react-autosuggest__input--focused {\n    outline: none;\n}\n\n.react-autosuggest__input--open {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.react-autosuggest__suggestions-container {\n    display: none;\n}\n\n.react-autosuggest__suggestions-container--open {\n    display: block;\n    position: absolute;\n    top: 29px;\n    width: 100%;\n    border: 1px solid #ddd;\n    background-color: #fff;\n    font-weight: normal;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n    text-align: left;\n    z-index: 2;\n}\n\n.react-autosuggest__suggestions-list {\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n}\n\n.react-autosuggest__suggestion {\n    cursor: pointer;\n    padding: 10px 20px;\n}\n\n.react-autosuggest__suggestion--highlighted {\n    background-color: #ddd;\n}\n\n.react-autosuggest__input_inputgroup {\n    width: 100%;\n    height: 30px;\n    padding: 0 10px;\n    border: none;\n    font-weight: normal;\n    border-radius: 0;\n}\n.ReactTable {\n    border: none;\n}\n\n.ReactTable .rt-thead.-header {\n    background-color: rgb(249, 250, 251);\n    border-bottom: 1px solid rgba(34, 36, 38, 0.0980392);\n    box-shadow: none;\n}\n\n.ReactTable .rt-td.-menu {\n    overflow: visible;\n}\n\n.ui.edit-input>input {\n    border: none;\n    padding: 2px 4px;\n}\n\n.ui.pagejump>input {\n    width: 60px;\n    text-align: right;\n}\n\n.ui.compartment-search > input {\n    border: none;\n    border-radius: 0;\n}\n\n.ui.compartment-search.ui.button {\n    border: none;\n    border-radius: 0;\n}\n\n.neuroglancer-side-panel-titlebar.neuroglancer-layer-side-panel-title {\n    background-color: rgb(39, 128, 220) !important;\n}\n\n.neuroglancer-viewer-top-row {\n    background-color: rgb(39, 128, 220) !important;\n}\n\n#neuroglancer-container {\n    overflow: hidden;\n    flex: 1;\n    color: white;\n    border: 0 solid black;\n    border-radius: 4px;\n    box-shadow: 0 1px 2px 0 rgba(34, 36, 38, .1);\n    box-sizing: content-box;\n    webkit-box-sizing: content-box;\n}\n\n#neuroglancer-container input {\n    margin: 3px\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
